var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('button',{staticClass:"btn btn-lg btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.loginClick()}}},[_c('i',{staticClass:"fab fa-google"}),_vm._v(" 使用google繼續\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }